<template>
  <div class="side-by-side-image-container" id="side-by-side-image" 
    @wheel.exact.prevent="handleCanvasWheel"
    v-hammer:press="handlePanstart"
    v-hammer:panstart="handlePanstart"
    v-hammer:pan="handlePanmove"
    v-hammer:panend="handlePanend">
    <annotateable-canvas
      id="side-by-side-primary-canvas-wrapper"
      :context="context"
      :imgIsLoading="imgIsLoading"
      :imgAvailable="imgAvailable"
      :imgNotFound="imgNotFound"
      :imgObject="displayImgObject"
      :imgSize="displayImgSize"
      :imgOffset="imgOffset"
      :colorSettings="imageColorSettings"
      :viewSize="largeViewSize"
      :viewFit="largeViewFit"
      :transform="transform"
      :isFlipped="isFlipped"
      :isFlipped90="isFlipped90"
      :annotations="annotations"
      :activeAnnotation="activeAnnotation"
      :realLocation="sidedRealLocation"
      :isInBounds="sidedIsInBounds"
      :annotationByPosition="annotationByPosition"
      :inMagnifyMode="inMagnifyMode"
      :inAddMode="inAddMode"
      :inEditMode="inEditMode"
      :isDragLock="isDragLock"
      :isMagnifying="isMagnifying"
      :magnifier="magnifier"
      :isSideBySide="true"
      @mousedownAnnotation="mousedownAnnotation"
      @mousemoveAnnotation="mousemoveAnnotation"
      @mouseupAnnotation="mouseupAnnotation"
      @deleteActiveAnnotation="deleteActiveAnnotation"
      @panBy="$emit('panBy', $event)"
      @updateMagnifier="updateMagnifier"
      @mousedownMagnifier="mousedownMagnifier"
      @mouseupMagnifier="mouseupMagnifier" />
  </div>
</template>

<script>
import annotateableCanvas from "../../canvas/components/AnnotateableCanvas";
import imageAnnotationHelper from "../mixins/ImageAnnotationHelper";
import touchMouseEvents from "../mixins/TouchMouseEvents";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SideBySideMainImageView",
  components: { annotateableCanvas },
  mixins: [ imageAnnotationHelper, touchMouseEvents ],
  props: [
    "largeViewSize",
    "largeViewFit",
    "transform",
    "realLocation",
    "isInBounds",
    "imgOffset",
    "isLeft",
    "context",
    "syncContext"
  ],
  data() {
    return {
      disableCustomEvents: false
    };
  },
  computed: {
    ...mapGetters([
      "sideBySideLeftImages",
      "sideBySideLeftIndex",
      "sideBySideRightImages",
      "sideBySideRightIndex",
    ]),
    sidedRealLocation() {
      return (x, y) => this.realLocation(this.isLeft, x, y);
    },
    sidedIsInBounds(){
      return (x, y) => this.isInBounds(this.isLeft, x, y);
    }
  },
  methods: {
    ...mapActions(["sideBySideSelectImage"]),

    handleInteractionStart(e) {
      const { x, y } = this.realLocation(e.offsetX, e.offsetY);
      if (this.isDragLock && !this.activeAnnotation) {
        this.setDisableCustomEvents(false);
        this.initiateDragStart(x, y);
      }
    },
    initiateDragStart(x, y) {
      this.dragStart = { x, y };
      this.dragStartCenter = {
        x: this.transform.centerX,
        y: this.transform.centerY
      };
      // logDetailed(
      //   "AnnotateableCanvas",
      //   "initiateDragStart",
      //   "dragStart",
      //   this.dragStart
      // );
    },
    updateDrag(x, y) {
      if (this.isMousedown)
        if (!this.dragStart) this.initiateDragStart(x, y);
        else this.dragTo(x, y);
      else this.clearDragStart();
    },
    dragTo(x, y) {
      let dx = this.dragStart.x - x;
      let dy = this.dragStart.y - y;
      // logDetailed("AnnotateableCanvas", "dragTo", "x", x, "y", y);
      this.$emit("panBy", { dx, dy });
    },
    clearDragStart() {
      this.dragStart = null;
      this.dragStartCenter = null;
    },
    setDisableCustomEvents(val) {
      this.disableCustomEvents = val;
    },
    handleCanvasWheel(e){     
      if (this.context.mouseWheelZoom) {
        let isLeft = this.isLeft;
        let images = isLeft
          ? this.sideBySideLeftImages
          : this.sideBySideRightImages;
        let index = isLeft ? this.sideBySideLeftIndex : this.sideBySideRightIndex;
        if (e.deltaY > 0) {
          index--;
          if (index < 0)
            index = images.length - 1;
        }
        else if (e.deltaY < 0) {
          index++;
          if (index > images.length - 1)
            index = 0;
        }
        let image = images[index];
        this.sideBySideSelectImage({image, isLeft});
      }
      else {
        this.$emit("updateZoom", this.transform.zoom + e.deltaY * -0.001);
        this.setCanvasLocation( e.offsetX, e.offsetY);
      }
    },
    setCanvasLocation(x, y) {
      const centerX = x / this.largeViewFit.w;
      const centerY = y / this.largeViewFit.h;
      this.$emit("updateCenter", { x: centerX, y: centerY });      
    }
  }
};
</script>

